export default "__VITE_ASSET__Dx8r1YaJ__"